import {defineStore} from "pinia";
import {ref} from "vue";
import {ProjectInfo} from "../models/project";
import {useProject} from "../composables/project";
import {useTaskTypesStore} from "./taskTypes";
import {useStorage} from "@vueuse/core";
import {useUserStore} from "./user";

export const useProjectStore = defineStore('project', () => {
    const project = ref<ProjectInfo | null>(null)
    const userStore = useUserStore()
    const lastProjects = useStorage<Map<string, ProjectInfo[]>>('lastProjects', new Map())
    const loading = ref(false)

    const taskTypeStore = useTaskTypesStore()

    async function select(id: number) {
        loading.value = true
        const {data} = await useProject(id)
        project.value = data.value
        const user = userStore.user;
        const projects = lastProjects.value.get(user.email) ?? []
        if (project.value) {
            projects.unshift(project.value)
            if (projects.length > 3) {
                projects.splice(3 - projects.length)
            }
            lastProjects.value = lastProjects.value.set(user.email, [...new Map(projects.map(item => [item.id, item])).values()])
        }
        await taskTypeStore.select(id)
        loading.value = false
    }

    return {project, select, loading, lastProjects}
})
